<mat-sidenav-container hasBackdrop="true" class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0">
    <div class="mx-auto flex w-full flex-wrap p-4">
        <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
            <div>
                <div class="flex items-center gap-1">
                    <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
                        <button mat-icon-button color="primary">
                        <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
                        </button>
                    </div>
                    <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
                        <div class="p-4">
                        <p>
                            Visualiza los clientes organizados por 
                            territorio y consulta su asignación.
                        </p>
                        </div>
                    </mat-menu>   
                    <h2 class="text-xl font-semibold leading-8 tracking-tight">
                        Clientes y territorios
                    </h2>
                </div>
                <div class="text-sm text-secondary font-medium tracking-tight">
                    Visualiza, los <b>clientes y territorios</b>.
                </div>
            </div>
            <!-- Header -->
            <div class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between">
                <div class="flex shrink-0">
                </div>
                <!-- Actions -->
                <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
                    <button class="ml-3 hidden sm:inline-flex" mat-flat-button [color]="'primary'" (click)="onExportButtonPressed()" matTooltip="Exportar">
                        <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:document-arrow-down'"></mat-icon>
                        <span class="ml-2">Exportar</span>
                    </button>
                </div>
            </div>
        </div>
        <div
            class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent">
            <div class="pt-1 mx-6">
                <app-smart-grid
                    [data]="data"
                    [columnDefs]="columnDefs"
                    [config]="gridConfig"
                    [loading]="isLoading"
                    [totalRecords]="totalItems"
                    (pageChanged)="onPageChange($event)"
                    (sortChanged)="onSortChange($event)">
                </app-smart-grid>
            </div>
        </div>
    </div>

    <!-- Filtros -->
    <app-filter (onFilterEvent)="findAllWithCount()" (onCleanEvent)="onClearFilter()" (onPanelOpened)="onFilterPanelOpened()">
        <app-routes-filters [form]="form" [territory]="true" [type]="true" [loadData]="loadFiltersData"></app-routes-filters>
        <app-configuration-filters [form]="form" [company]="true" [loadData]="loadFiltersData"></app-configuration-filters>
    </app-filter>
</mat-sidenav-container>